import { en, type ChromeMessages } from "./chrome_en.ts";

/** German web app chrome. Unlisted keys stay English (product names and tokens). */
export const de: ChromeMessages = {
  ...en,
  appTitle: "intEHRgrator — Integrationswerkbank",
  copyPrompt: "Prompt kopieren",
  copyPromptTitle: "KI-Prompt mit eingebetteten Dateien kopieren",
  callAi: "KI aufrufen",
  callAiTitle: "Konfigurierte KI mit Mapping-Werkzeugen aufrufen (MCP- / Agent-API-Namen)",
  aiMenuAria: "KI-Hilfe",
  menuCopyPrompt: "Prompt kopieren",
  menuCallAi: "KI aufrufen",
  menuAiCredentials: "KI-Zugangsdaten konfigurieren…",
  menuEmbedFiles: "Dateien in den Prompt einbetten",
  menuAttachFiles: "Dateien im Chat anhängen",
  menuBrowseUris: "URIs durchsuchen (falls vorhanden)",
  menuAiCopyHeading: "kopieren/einfügen für externen KI-Chat",
  menuAiOwnHeading: "Eigene KI",
  menuAiDesktopHeading: "Desktop-App",
  menuLocalMcp: "Lokaler MCP-Server…",
  localMcpTitle: "Lokaler MCP-Server",
  localMcpIntro:
    "Starten oder stoppen Sie den Server, den Ihre IDE zum Bearbeiten dieser Arbeitsfläche nutzt. Kopieren Sie die Konfiguration in die MCP-Einstellungen der IDE. Lassen Sie diese App geöffnet.",
  localMcpRunning: "Läuft — eine IDE kann sich verbinden",
  localMcpStopped: "Gestoppt — IDEs können diese Arbeitsfläche nicht ändern",
  localMcpStart: "Starten",
  localMcpStop: "Stoppen",
  localMcpUrlLabel: "Agent-API-URL",
  localMcpTokenLabel: "Token",
  localMcpNoToken: "Kein Token (nur Loopback)",
  localMcpConfigLabel: "IDE-Konfiguration (mcp.json)",
  localMcpCopy: "Konfiguration kopieren",
  localMcpCopied: "Konfiguration kopiert",
  localMcpUnavailable: "Der Desktop-Server hat nicht geantwortet.",
  menuFile: "Datei",
  menuAi: "KI",
  importAi: "KI-Vorschläge importieren",
  exampleSets: "Beispielsets",
  exampleSetsTitle: "Ein vollständiges Beispielset (Quelle, Ziel, optionales Mapping) aus Katalog-URIs laden",
  exampleSetsMenuAria: "Beispielset wählen",
  functions: "Funktionen",
  functionsTitle: "Blockly-Funktionen speichern, laden oder beisteuern; GitHub-Funktionsbibliothek durchsuchen",
  newProject: "Neues Projekt",
  loadProject: "Projekt laden",
  saveAs: "Speichern unter",
  exportProject: "Projekt exportieren",
  importProject: "Projekt importieren",
  betterForm: "Better-Formular öffnen",
  betterFormTitle: "Der lizenzierte Better-Renderer bleibt in diesem Browser. Laden Sie ihn im Viewer hoch, falls er fehlt.",
  help: "Hilfe",
  helpTitle: "Anleitung und Fehlermeldungen",
  helpMenuAria: "Hilfemenü",
  userTutorial: "Benutzeranleitung",
  reportBug: "Fehler melden",
  requestFeature: "Funktion vorschlagen",
  uiLanguageAria: "Sprache der Oberfläche",
  showSource: "Quelle",
  source: "Quelle",
  clickToMapAria: "Per Klick nach Handlebars mappen",
  clickToMapHtml:
    "Klicken Sie einen Knoten im Quellschema oder in der Beispielinstanz, um ihn in den gewählten Blockly-Block zu mappen. Ist ein Code-Textblock (LANG = Handlebars) oder ein Handlebars-Textblock gewählt, wird ein VMS-Hbs-{{path}} an der Einfügemarke eingesetzt. Umschalt hält verschachteltes {{#with}} / {{#each}}. Sonst füllt der Hörmodus den wartenden Quellabfrage-Block.",
  slideSourceAway: "Quelle wegschieben",
  handlebarsHint: "Handlebars-Einfügen bereit — Knoten für {{path}} klicken; Umschalt+Klick für verschachteltes #with/#each.",
  schemaFormatsAria: "Unterstützte Schemaformate",
  schemaFormatsHtml:
    "Unterstützt: JSON Schema, JSON- oder XML-Dokumente, XSD-Beispiele sowie openEHR Web Template, Composition-JSON oder eine GitHub-.t.json (Archetypen aus demselben Repo).<br>Aus lokaler Datei, URL oder ▾ → Aus GitHub-Vorlage… laden.",
  loadSchema: "Schema laden",
  schemaMenuAria: "Weitere Arten, ein Schema zu laden",
  examples: "Beispiele",
  exampleFormatsAria: "Unterstützte Beispielformate",
  exampleFormatsHtml:
    "Unterstützt: JSON- oder XML-Instanzdateien.<br>Eine Datei, einen lokalen Ordner, einen GitHub-Ordner (▾) oder eine einzelne Datei per URL laden.",
  addExample: "+ Beispiel hinzufügen",
  exampleMenuAria: "Weitere Arten, Beispiele zu laden",
  mappingEditors: "Mapping-Editoren",
  undo: "Rückgängig",
  redo: "Wiederholen",
  expandAll: "Alle aufklappen",
  expandAllTitle: "Alle verschachtelten Blöcke aufklappen",
  collapseAll: "Alle zuklappen",
  collapseAllTitle: "Alle verschachtelten Blöcke zuklappen",
  expandChildren: "Kinder aufklappen",
  collapseChildren: "Kinder zuklappen",
  useCodedText: "Codierten Text verwenden (DV_CODED_TEXT)",
  usePlainText: "Einfachen Text verwenden (DV_TEXT)",
  followAgent: "Agent folgen",
  followAgentTitle: "Wenn aktiv, schwenkt die Hauptfläche zu Blöcken, die ein Agent gerade geändert hat",
  openViewer: "Ansichtsfenster öffnen",
  openViewerTitle: "Ansichtsfenster öffnen: Live-Fläche, Agentenlegende und zugeschriebene Historie",
  downloadJson: "JSON herunterladen",
  downloadWorkspaceTitle: "Vollständiges Blockly-Arbeitsflächen-JSON herunterladen (inkl. Koordinaten und Layout)",
  mappingViewsAria: "Textansichten des Mapping-Editors",
  mappingSpec: "Mapping-Spezifikation",
  specLayoutAria: "Ansicht der Mapping-Spezifikation",
  listView: "Listenansicht (alle Wurzeln)",
  tabbedView: "Registeransicht (je Wurzel)",
  download: "Herunterladen",
  downloadSpecTitle: "Vollständiges Blockly-Arbeitsflächen-JSON herunterladen",
  downloadSpecAria: "Vollständiges Blockly-Arbeitsflächen-JSON herunterladen",
  upload: "Hochladen",
  uploadSpecTitle: "Eine Blockly-Arbeitsflächen-JSON-Datei hochladen",
  uploadSpecAria: "Eine Blockly-Arbeitsflächen-JSON-Datei hochladen",
  specEditorActionsAria: "Aktionen der Mapping-Spec-Editor",
  searchSpecTitle: "In Mapping Spec suchen",
  searchSpecAria: "In Mapping Spec suchen",
  copySpecTitle: "Mapping Spec kopieren",
  copySpecAria: "Mapping Spec kopieren",
  scriptEditorActionsAria: "Aktionen der Konvertierungsskript-Editor",
  searchScriptTitle: "In Konvertierungsskript suchen",
  searchScriptAria: "In Konvertierungsskript suchen",
  copyScriptTitle: "Konvertierungsskript kopieren",
  copyScriptAria: "Konvertierungsskript kopieren",
  downloadScriptAria: "Konvertierungsskript herunterladen",
  testEditorActionsAria: "Aktionen der Testausgabe-Editor",
  searchTestTitle: "In Testausgabe suchen",
  searchTestAria: "In Testausgabe suchen",
  copyTestTitle: "Testausgabe kopieren",
  copyTestAria: "Testausgabe kopieren",
  downloadTestAria: "Ausgabe des Konvertierungstests herunterladen",
  markWarned: "Gewarnte Optionale markieren",
  markWarnedTitle: "Nicht gemappte optionale Gerüstbäume mit Einschränkungswarnung markieren",
  deleteMarked: "Markierte löschen",
  deleteMarkedTitle: "Angehakte Knoten und ihre Kinder von der Fläche löschen",
  undoHistoryHint: "Tipp: Fläche öffnen (Beobachter) für die volle Agenten-Zeitlinie und zugeschriebene Historie.",
  undoLastEdit: "Letzte Änderung auf der Fläche rückgängig.",
  redoLastEdit: "Änderung auf der Fläche wiederholen.",
  railTarget: "Zielschema",
  railTargetTitle: "Zielschema",
  railScripts: "Skripte",
  railScriptsTitle: "Erzeugte Konvertierungsskripte",
  railTestTitle: "Konvertierungstests",
  targetPreviews: "Ziel und Vorschau",
  targetFormatsAria: "Unterstützte Zielformate",
  targetFormatsHtml:
    "Unterstützt: openEHR OPT/OPT2, Web Template, JSON Schema, XML Schema (XSD), ADL, freie Vorlagen oder eine GitHub-.t.json (Archetypen aus demselben Repo).<br>Ziel und Standardkontextabbildung gemeinsam wählen. ▾ bietet auch Datei, URL, GitHub und zerstörungsfreies Aktualisieren.",
  loadTarget: "Ziel und Standardkontextabbildung laden",
  loadTargetTitle: "Ein Ziel laden und eine Standardkontextabbildung wählen",
  targetMenuAria: "Weitere Arten, ein Ziel zu laden",
  modelLanguageAria: "Ontologiesprache des Zielmodells",
  scriptFormatsAria: "Formate der Konvertierungsskripte",
  scriptFormatsHtml:
    "Die Mapping-Vorschau deutet das Mapping, ohne ein Skript zu erzeugen. Konvertierungsskripte (bisher): TypeScript, Java, Handlebars, XQuery und Go Template. TypeScript, Handlebars, Go Template und XQuery laufen auch im Konvertierungstest. Java erzeugt eine Archie-Klasse, führt sie in der Web-App aber nicht aus. Bei openEHR-Zielen wählt JSON- oder XML-Instanz, wie XQuery die Composition serialisiert.<br>Herunterladen im Skripteditor speichert das erzeugte Skript. Herunterladen über dem Konvertierungstest speichert diese Instanz.",
  mappingPreview: "Mapping-Vorschau",
  instance: "Instanz",
  instanceTitle: "Gewünschte openEHR-Instanzform. XQuery-Export und Testlauf nutzen diese Serialisierung.",
  jsonInstance: "JSON-Instanz",
  xmlInstance: "XML-Instanz",
  slideTargetAway: "Ziel und Vorschau wegschieben",
  tabTargetSchema: "Zielschema",
  tabScripts: "Erzeugte Konvertierungsskripte",
  tabTest: "Konvertierungstests",
  generatedScripts: "Erzeugte Konvertierungsskripte",
  downloadScriptTitle: "Konvertierungsskript herunterladen",
  testRuns: "Konvertierungstests",
  validateAs: "Validieren als",
  validateTitle: "ehrtslib-Voreinstellung des JSON-Deserialisierers für die Vorlagenprüfung",
  hybrid: "Hybrid (nachsichtig)",
  defaultMode: "Standard",
  compact: "Kompakt",
  canonicalStrict: "Kanonisch strikt",
  terse: "Knapp",
  runTest: "Test ausführen",
  autoplay: "▶ Autoplay",
  pause: "⏸ Pause",
  downloadTestTitle: "Ausgabe des Konvertierungstests herunterladen",
  ready: "Bereit",
  loadSchemaEmpty: "Eine Schemadatei laden.",
  selectExampleTab: "Einen Beispielreiter wählen.",
  addExamplesEmpty: 'Beispielinstanzen hinzufügen, um "Konvertierungstests" unter Ziel und Vorschau zu aktivieren',
  loadTargetEmpty: "Ein Zielschema oder eine Vorlage laden.",
  statusNoTarget: "Kein Ziel",
  statusTarget: "Ziel: {id}",
  statusScript: "Skript: {name}",
  statusNoExample: "Kein Beispiel",
  statusExample: "Beispiel: {name}",
  statusUnmapped: "{n} ungemappte Pflichtfelder",
  unsavedChanges: "ungespeicherte Änderungen",
  autosavedAt: "automatisch gespeichert um {time}",
  functionsIntroHtml:
    "Eine Blockly-Funktion (Definition + Entscheidungstabellen) auf die Platte speichern, eine in dieses Mapping laden oder die GitHub-Funktionsbibliothek durchsuchen. Beisteuern öffnet ein Prüf-Issue — es wird nicht automatisch gemergt.",
  onThisCanvas: "Auf dieser Fläche",
  loadFromDisk: "Von Datenträger laden…",
  functionLibrary: "Funktionsbibliothek",
  catalogUrl: "Katalog-URL",
  loadCatalog: "Katalog laden",
  close: "Schließen",
  nameInUse: "Name wird bereits verwendet",
  cancel: "Abbrechen",
  replace: "Ersetzen",
  rename: "Umbenennen",
  contributeTitle: "Funktion beisteuern",
  contributeIntroHtml:
    "Öffnet ein GitHub-Issue in <code>regionstockholm/intehrgrator</code> mit Ihrer Beschreibung und der Funktionsdefinition. Maintainer prüfen von Hand.",
  functionName: "Funktion:",
  descriptionRequired: "Beschreibung (erforderlich)",
  contributePlaceholder: "Was sie liefert, Sprache, Entscheidungstabelle, Parameter…",
  needGithubHtml:
    'GitHub-Konto nötig? <a id="function-contribute-signup" href="https://github.com/signup" target="_blank" rel="noopener noreferrer">Konto erstellen</a> oder <a id="function-contribute-login" href="https://github.com/login" target="_blank" rel="noopener noreferrer">anmelden</a>, dann absenden.',
  openGithubIssue: "GitHub-Issue öffnen",
  saveAsIntro: "Die aktuelle Arbeitsfläche unter einem Namen speichern, den Sie später laden können.",
  projectName: "Projektname",
  projectNamePlaceholder: "Mein Integrationsprojekt",
  save: "Speichern",
  loadProjectTitle: "Projekt laden",
  loadProjectIntro: "Eine gespeicherte Arbeitsfläche wählen. Laden ersetzt das aktuelle Projekt.",
  loadFromUrl: "Von URL laden",
  loadUrlHint: "Eine https-URL einfügen. GitHub-Dateiseiten werden in Rohinhalt umgewandelt.",
  recentUrls: "Zuletzt verwendete URLs",
  load: "Laden",
  jointTitle: "Ziel und Standardkontextabbildung laden",
  jointIntroHtml:
    "Ziel und Standardkontextabbildung gemeinsam wählen. Bestätigen baut das <strong>Vorlagenskelett</strong> und die <strong>Standardpunkte</strong>. <strong>Neu</strong> lädt das Ziel nur in den Reiter Zielschema, damit Sie Chips und Werte ziehen und dann auf der Fläche anwenden.",
  targetLegend: "Ziel",
  noTargetYet: "Noch kein Ziel gewählt.",
  fromFile: "Aus Datei…",
  useLoadedTarget: "Geladenes Ziel verwenden",
  targetUrl: "Ziel-URL",
  fetchUrl: "URL abrufen",
  mapLegend: "Standardkontextabbildung",
  factoryMapHtml: "openEHR-Fabrik (<code>defaults_openEHR_1</code>)",
  keepMap: "Die Abbildung behalten, die schon auf der Fläche liegt",
  newMap: "Neu (leer) — zuerst Zielschema, dann Anwenden",
  browsedFile: "Gewählte Datei",
  browseMap: "Abbildungsdatei durchsuchen…",
  loadAndScaffold: "Laden und Gerüst bauen",
  loadIntoSchema: "In Zielschema laden",
  refreshReport: "Aktualisierungsbericht",
  copyMergePrompt: "Zusammenführungs-Prompt kopieren",
  aiCredentialsTitle: "KI-Zugangsdaten",
  aiCredentialsIntroHtml:
    'Optionaler OpenAI-kompatibler Chat-Endpunkt, damit <strong>KI aufrufen</strong> aus der Web-App mappen kann. Die Zugangsdaten bleiben nur in diesem Browser — nicht im Projektpaket. <strong>KI aufrufen</strong> kann dieselben Mapping-Werkzeuge nutzen wie MCP / die HTTP-Agent-API (<code>map_slot</code>, <code>import_suggestions</code>, <code>run_test</code>, …). Eine KI-gestützte IDE mit lokalem MCP bleibt ein eigener, voll gültiger Weg. Schritt-für-Schritt-Seiten: <a href="https://github.com/regionstockholm/intehrgrator/blob/main/docs/AI_CREDENTIALS.md" target="_blank" rel="noopener noreferrer" id="ai-credentials-guide">Zugangsdaten für KI aufrufen</a>.',
  provider: "Anbieter",
  customEndpoint: "Eigener OpenAI-kompatibler Endpunkt",
  getApiKey: "API-Schlüssel holen",
  providerDocs: "Anbieterdoku",
  endpoint: "Endpunkt",
  apiKey: "API-Schlüssel",
  model: "Modell",
  clear: "Leeren",
  defaultsTitle: "Standardkontextabbildung",
  defaultsIntro: "Eine gespeicherte Abbildung laden, Datei oder URL durchsuchen, die eindeutige Standardkontextabbildung herunterladen oder die Abbildung der Fläche unter einem Namen speichern.",
  browseFile: "Datei durchsuchen…",
  loadUrlBtn: "URL laden",
  downloadFile: "Datei herunterladen…",
  saveAsEllipsis: "Speichern unter…",
  saveDefaultsTitle: "Standardkontextabbildung speichern unter",
  saveDefaultsIntro: "Die aktuelle Standardkontextabbildung unter einem Namen speichern, den Sie später wählen können.",
  nameLabel: "Name",
  hardcodeTitle: "Eintrag der Standardkontextabbildung fest einsetzen",
  hardcodeIntroHtml:
    "Wählen Sie einen Abbildungsschlüssel zum <strong>Einbetten</strong> auf der Fläche. Jede Suche <code>get defaults key …</code> nach diesem Schlüssel wird durch eine Kopie des Werts aus dieser Standardkontextabbildung ersetzt. Danach lesen diese Plätze das Konvertierzeit-Argument <code>defaults</code> nicht mehr — sie nutzen den eingesetzten Block. Die Abbildung selbst bleibt unverändert, damit Sie später weitere Schlüssel einsetzen können.",
  importAiTitle: "KI-Vorschläge importieren",
  importAiIntroHtml:
    "JSON aus dem KI-Chat einfügen (ein rohes Objekt oder ein <code>intehrgrator-suggestions</code>-Zaun). Der Import wird gegen das Vorschlags-JSON-Schema geprüft; Fehler bleiben hier sichtbar und können an die KI zurückkopiert werden.",
  suggestions: "Vorschläge",
  pasteClipboard: "Zwischenablage einfügen",
  copyErrorsForAi: "Fehler für die KI kopieren",
  copied: "Kopiert",
  importAction: "Importieren",
  notRecommended: "Nicht die empfohlene Version",
  bleedingEdgeHtml:
    'Lieber experimentieren? Der allerneueste Build (bei jeder Änderung an <code>main</code>) liegt immer unter <a id="recommended-version-bleeding-edge-link" href="#">der Seitenwurzel</a>.',
  newHereHtml:
    'Neu hier? Lesen Sie die <a id="recommended-version-tutorial-link" href="#">Anleitung</a> oder die <a id="recommended-version-readme-link" href="#">README</a>.',
  dontShowAgain: "Für diese Version nicht wieder anzeigen",
  dismiss: "Schließen",
  defaultsBlockAria: "Über die Standardkontextabbildung",
  defaultsBlockHtml:
    "<strong>Standardkontextabbildung</strong> ist die eindeutige Tabelle, die Sie hier auf der Fläche schreiben. Zur <em>Konvertierzeit</em> erhalten erzeugte Konvertierungsskripte sie als Argument <code>defaults</code>, geschlüsselt mit dem <strong>Laufzeitschlüssel</strong> (<code>language</code>, <code>facility</code>, …). <code>maps_get(\"defaults\", runtimeKey)</code> schlägt sie nach. Laufzeitcode kann diesen Beutel mit Werten je Nachricht, anderen benannten Abbildungen und Blättern mischen — die Flächenabbildung ist die wiederverwendbare Basis, keine Literale in jedem Platz.<br><strong>Gerüstziele</strong> (Chips) sind nur RM-Pfade beim Schreiben, keine Laufzeitschlüssel: <code>Class.attribute</code> (z. B. <code>COMPOSITION.composer</code>, <code>EVENT_CONTEXT.health_care_facility</code>), Ahnenpfade und Platzhalter (<code>*.language</code> leuchtet jeden Sprachplatz). Ein spezifischerer Chip gewinnt, wenn mehrere denselben Platz treffen. Leere Chips → ein reiner Laufzeitschlüssel, der nichts leuchten lässt.<br>Bestätigen, <strong>Standardkontextabbildung anwenden</strong> oder eine spätere Zielaktualisierung verbinden <strong>Standardpunkte</strong>. Wertänderungen sind im Testlauf live. Ein schon aus der Quelle gemappter Platz wird nicht ersetzt.",
  decisionBlockAria: "Über Entscheidungstabellen",
  decisionBlockHtml:
    "<strong>Entscheidungstabelle</strong> ist ein benanntes Regelgitter unter Tabellen und Blätter: Bedingungsspalten (Gleichheit, egal <code>—</code>) und Ausgabespalten (Werte oder VMS-Mustache-Schnipsel). Das Gitter besitzt Spaltennamen und Typen; die Eingabe-Kartenschlüssel des Blocks bleiben synchron.<br>Rechts eine Eingabekarte anschließen (Schlüssel = Bedingungsköpfe). Die Auswahlliste liefert eine typisierte Spalte (🔤 Zeichenkette, 🔢 Zahl, ✓ Boolesch) oder <em>alle Ausgaben</em> als Karte (↦). Ein Typwechsel kann den Block lösen; Rückgängig auf der Fläche stellt ihn wieder her.<br>Trefferpolitik (FIRST / UNIQUE / COLLECT) liegt unter Tabellen und Blätter. Verschachtelte Quellen vor der Auswertung in die Eingabekarte (oder über Variablen) flach machen.",
  fromUrl: "Von URL…",
  refreshFromFile: "Aus Datei aktualisieren…",
  refreshFromUrl: "Von URL aktualisieren…",
  noRecentUrls: "Noch keine zuletzt verwendeten URLs.",
  removeFromHistory: "{url} aus dem Verlauf entfernen",
  enterUrl: "Eine URL eingeben.",
  refreshKindFromUrl: "{kind} von URL aktualisieren",
  refreshUrlHint: "Diese Datei von einer URL neu laden, ohne Mappings auf der Fläche zu löschen. Warnungen nennen Plätze oder Pfade, die vielleicht nicht mehr passen.",
  kindExample: "Beispiel",
  kindTarget: "Ziel",
  kindSource: "Quelle",
  fromLocalFolder: "Aus lokalem Ordner…",
  fromGithubFolder: "Aus GitHub-Ordner…",
  fromGithubTemplate: "Aus GitHub-Vorlage…",
  loadSchemaFromUrl: "Schema von URL laden",
  loadSchemaUrlHint: "JSON, XML, XSD oder eine GitHub-.t.json-Vorlage (Archetypen aus demselben Repo). GitHub-Dateiseiten werden in Rohinhalt umgewandelt.",
  recentSchemaUrls: "Zuletzt verwendete Schema-URLs",
  githubTemplateTitle: "openEHR-Vorlage von GitHub laden",
  githubTemplateHint: "Eine GitHub-Blob- oder Roh-URL zu einer Better-.t.json (oder .adl / .opt) einfügen. Abhängige Archetypen kommen aus demselben Branch.",
  githubTemplateOpenTitle: "openEHR-Vorlage von GitHub öffnen",
  addExampleFromUrl: "Beispiel von URL hinzufügen",
  addExampleUrlHint: "JSON- oder XML-Instanz. GitHub-Dateiseiten werden in Rohinhalt umgewandelt.",
  recentExampleUrls: "Zuletzt verwendete Beispiel-URLs",
  githubFolderTitle: "Beispiele aus GitHub-Ordner hinzufügen",
  githubFolderHint: "Eine GitHub-Baum-URL zu einem Ordner einfügen. Alle JSON- und XML-Dateien unter diesem Pfad werden geladen.",
  loadTargetFromUrl: "Ziel von URL laden",
  loadTargetUrlHint: "OPT, Web Template, JSON Schema oder eine GitHub-.t.json. GitHub-Dateiseiten werden in Rohinhalt umgewandelt.",
  recentTargetUrls: "Zuletzt verwendete Ziel-URLs",
  loadingCatalog: "Katalog wird geladen…",
  exampleSetsHeading: "Beispielsets",
  noExampleSets: "Keine Beispielsets im Katalog",
  catalog: "Katalog",
  bundledCatalog: "Mitgelieferter Dummy-Katalog",
  ehrtslibCatalog: "ehrtslib-Katalog (GitHub)…",
  loadCatalogFromUrl: "Katalog von URL laden…",
  catalogUrlPrompt: "JSON-URL des Beispielset-Katalogs",
  confirmLoadExampleSet: "Dieses Beispielset laden? Die aktuelle Arbeitsfläche wird ersetzt. Ungespeicherte Änderungen können verloren gehen.",
  confirmNewProject: "Ein neues Projekt starten? Die aktuelle Arbeitsfläche wird geleert. Ungespeicherte Änderungen können verloren gehen.",
  confirmNewEmpty: "Ein neues leeres Projekt starten?",
  confirmLoadProject: "Dieses Projekt laden? Die aktuelle Arbeitsfläche wird ersetzt.",
  noSavedProjects: "Noch keine gespeicherten Projekte. Speichern unter verwenden oder auf die automatische Speicherung warten.",
  lastAutosave: "Letzte automatische Speicherung",
  savedProject: "Gespeichertes Projekt",
  defaultsUnavailable: "Katalog der Standardwerte nicht verfügbar: {detail}",
  noSavedMaps: "Noch keine gespeicherten Standardkontextabbildungen. Speichern unter, Herunterladen, Datei durchsuchen oder eine URL verwenden.",
  savedMap: "Gespeicherte Abbildung",
  noHardcodeEntries: "Die Standardkontextabbildung hat noch keine Einträge zum Einsetzen.",
  selectedFile: "Gewählt: {name}",
  usingLoaded: "Verwende geladen: {name}",
  fetchedFile: "Abgerufen: {name}",
  browsedFileLabel: "Gewählte Datei: {name}",
  pasteTargetUrl: "Zuerst eine Ziel-URL einfügen.",
  popupBlockedSvg: "Popup blockiert — stattdessen SVG heruntergeladen.",
  popupBlockedEmpty: "Popup blockiert und die Fläche ist leer.",
  openedObserver: "Agentenbeobachter / Momentaufnahme der Fläche geöffnet.",
  betterPopupBlocked: "Die Better-Formularansicht konnte nicht geöffnet werden. Pop-ups für diese Website zulassen.",
  schemaMismatch: "Schemaabweichung:",
  conversionFailed: "Konvertierung fehlgeschlagen:",
  templateValidation: "Vorlagenprüfung:",
  noWorkspace: "Keine Blockly-Arbeitsfläche",
  noFunctionsOnCanvas: "Keine Funktionen auf der Fläche. In eine Funktion auslagern oder aus der Bibliothek laden.",
  contribute: "Beisteuern",
  loadCatalogBrowse: "Katalog laden, um kuratierte Funktionen zu durchsuchen.",
  catalogNoFunctions: "Der Katalog enthält keine Funktionen.",
  loadingLibrary: "Funktionsbibliothek wird geladen…",
  fnReturnsValue: "{sig} → Wert",
  pasteJsonFirst: "Zuerst das KI-JSON (oder einen intehrgrator-suggestions-Zaun) einfügen",
  clipboardEmpty: "Die Zwischenablage ist leer oder in diesem Browser nicht lesbar",
  noMatches: "Keine Treffer",
  searchPlaceholder: "Suchen…",
  filterList: "Liste filtern",
  historyTimeline: "Historienzeitlinie",
  historyIntro: "Ziehen zum Vorschauen; Rollback schneidet spätere Einträge ab. Patch-Rückgängig liefert intehrgrator-suggestions v2 JSON.",
  seqLabel: "Seq",
  previewAtSeq: "Vorschau bei Seq",
  rollbackHere: "Bis hier zurückrollen (zerstörend)",
  copyPatchUndo: "Prompt für Patch-Rückgängig kopieren",
  timelineDesktopOnly: "Die Agent-API-Zeitlinie gibt es nur in der Desktop-App.",
  timelineUnavailable: "Agent-API nicht verfügbar — Zeitlinie wartet.",
  noHistoryYet: "Noch keine Historie.",
  selectHistoryPoint: "Einen Historienpunkt wählen.",
  downloadDiscardedConfirm: "Den verworfenen Zweig (.intehrgrator) herunterladen, bevor Sie fortfahren?",
  noBundleExport: "Keine Paketdaten zum Exportieren für den verworfenen Zweig.",
  downloadedDiscarded: "Verworfenen Zweig heruntergeladen.",
  agentsHeading: "Agenten",
  projectLoaded: "Projekt geladen",
  newProjectStatus: "Neues Projekt",
  projectNotFound: "Projekt nicht gefunden",
  projectImported: "Projekt importiert",
  restoredMapping: "Vorheriges Mapping wiederhergestellt",
  blocklyMustBeObject: "Blockly-JSON muss ein Objekt sein",
  exampleDropJsonXml: "Beispielablage: nur JSON- oder XML-Dateien",
  listeningSourceQuery: "Warte auf Quellpfad → Quellabfrage",
  appliedDefaults: "Standardkontextabbildung angewendet",
  refreshPromptCopied: "Zusammenführungs-Prompt kopiert",
  callingAi: "KI wird aufgerufen…",
  providerRejectedTools: "Anbieter hat Mapping-Werkzeuge abgelehnt; erneuter Versuch mit Vorschlags-JSON…",
  aiCredentialsCleared: "KI-Zugangsdaten gelöscht",
  aiCredentialsSaved: "KI-Zugangsdaten in diesem Browser gespeichert",
  saveAiOrCopy: "KI-Zugangsdaten speichern, um die KI aufzurufen, oder Prompt kopieren verwenden.",
  loadTargetFirst: "Zuerst ein Ziel in das Zielschema laden, dann die Standardkontextabbildung anwenden.",
  targetNodeMissing: "Dieser Zielschema-Knoten ist nicht im geladenen Ziel.",
  dropLeafHint: "Ein Blatt auf Gerüst-Chips, einen Teilbaum auf eine Wertbuchse oder auf die leere Fläche legen.",
  emptyMapReady: "Leere Standardkontextabbildung bereit — aus dem Zielschema ziehen, dann anwenden.",
  pickTargetFirst: "Zuerst eine Zieldatei oder URL wählen.",
  corsCallAiHint: "Browser-CORS blockiert Cloud-Anbieter von GitHub Pages oft. Die Desktop-App verwenden (sie leitet KI aufrufen weiter), CORS auf einem lokalen Server aktivieren (Ollama / LM Studio) oder Prompt kopieren verwenden.",
  savedAs: 'Gespeichert unter "{name}"',
  loadedSchema: "Schema {name} geladen",
  loadedBlockly: "Blockly-Mapping {name} geladen",
  loadedTargetIntoSchema: "{format}-Ziel {id} in das Zielschema geladen (noch kein Produktgerüst)",
  loadedTarget: "{format}-Ziel {id} geladen",
  loadedFunctionLibrary: "Funktionsbibliothek geladen ({n})",
  loadedFunction: "Funktion {name} geladen",
  loadedExampleCatalog: "Beispielset-Katalog geladen ({n} {sets})",
  setSingular: "Set",
  setPlural: "Sets",
  loadedExampleSet: 'Beispielset "{name}" geladen',
  exampleSetFailed: 'Beispielset "{name}" fehlgeschlagen: {detail}',
  addedExample: "Beispiel {name} hinzugefügt",
  addedExampleMismatch: "Beispiel {name} mit {n} Schema-{mismatch} hinzugefügt",
  mismatchSingular: "Abweichung",
  mismatchPlural: "Abweichungen",
  addedExamples: "{n} Beispiele hinzugefügt",
  addedExamplesMismatch: "{n} Beispiele mit {m} Schema-{mismatch} hinzugefügt",
  aiPromptCopied: "KI-Prompt kopiert ({delivery})",
  listeningSlot: "Warte auf Quellpfad → {slot}",
  mappedWhat: "{what} gemappt",
  mappedSourceQuery: "Quellabfrage {xpath} gemappt",
  importSummary: "Import: {applied} angewendet, {loops} Schleifen, {skipped} übersprungen, {errors} Fehler{schema}",
  importSchemaNote: ", {n} Schema",
  importFailed: "Import fehlgeschlagen: {detail}",
  targetLoadFailed: "Ziel laden fehlgeschlagen: {detail}",
  exampleLoadFailed: "Beispiel laden fehlgeschlagen: {detail}",
  exampleFolderFailed: "Beispielordner laden fehlgeschlagen: {detail}",
  functionCatalogFailed: "Funktionsbibliothekskatalog fehlgeschlagen: {detail}",
  exampleCatalogFailed: "Beispielset-Katalog fehlgeschlagen: {detail}",
  blocklyParseFailed: "Blockly-JSON konnte nicht gelesen werden: {detail}",
  couldNotLoad: "{name} konnte nicht geladen werden: {detail}",
  autosaveFailed: "Automatisches Speichern fehlgeschlagen: {detail}",
  modelLanguageStatus: "Modellsprache: {language}",
  refreshedClean: "{kind} {name} ohne Mapping-Konflikte aktualisiert.",
  refreshedWithWarnings: "{kind} aktualisiert {previous} → {next}",
  warningCount: "{n} {warnings}:",
  warningSingular: "Warnung",
  warningPlural: "Warnungen",
  loadedGithubTemplate: "GitHub-Vorlage {id} geladen ({n} Dateien){extra}",
  loadedGithubSchema: "GitHub-Schema {id} geladen ({n} Dateien){extra}",
  warningsParen: " ({n} Warnungen)",
  callAiFailed: "KI aufrufen fehlgeschlagen: {detail}",
  scaffoldTarget: "Gerüstziel {path} (Chip klicken, um *. umzuschalten)",
  nestedOnMap: "{label} in die Standardkontextabbildung verschachtelt",
  addedMapEntry: "Eintrag {key} ({path}) in Zeile {row} hinzugefügt",
  addedFromTarget: "{label} aus dem Zielschema hinzugefügt",
  addedSource: "Quelle {xpath} hinzugefügt",
  taskLoadGithub: "Klinisches Modell von GitHub laden",
  taskLoadAndScaffold: "Ziel laden und Gerüst bauen",
  taskLoadExampleSet: "Beispielset laden",
  taskLoadTarget: "Ziel laden",
  taskLoadSchema: "Quellschema laden",
  taskLoadMapping: "Mapping laden",
  taskLoadSheets: "Blätter laden",
  taskLoadDefaults: "Standardabbildung laden",
  taskParseUrl: "GitHub-URL lesen",
  taskIndexTree: "Repository-Dateien auflisten",
  taskFetchFiles: "Dateien des klinischen Modells holen",
  taskParseModels: "Vorlagen und Archetypen lesen",
  taskResolveOpt: "Operative Vorlage auflösen",
  taskScaffold: "Vorlagenskelett bauen",
  taskGenerate: "Konvertierungsskript erzeugen",
  taskLoadExampleN: "Beispiel {n} laden",
  appDescription: "intEHRgrator — visuelle Integrationswerkbank zum Abbilden von Quelldaten auf openEHR",
  loadedColon: "Geladen: {name}",
  savedColon: "Gespeichert: {name}",
  noMappingConflicts: "Keine Mapping-Konflikte.",
  refreshReportLine: "{kind} {previous} → {next}",
  refreshWarningCount: "{n} Warnung(en):",
  hardcodedLookups: "„{key}“ in {n} {lookups} fest eingebaut",
  lookupSingular: "Nachschlagen",
  lookupPlural: "Nachschlagen",
  noDefaultsLookups: "Keine maps_get(\"defaults\", \"{key}\")-Nachschlagen auf der Fläche",
  callAiResult: "KI aufrufen: {applied} angewendet · {errors} Fehler{extra}",
  functionLibraryCount: "Funktionsbibliothek: {n} {functions}",
  functionSingular: "Funktion",
  functionPlural: "Funktionen",
  renamedFromParen: " (umbenannt von {name})",
  savedBundle: "{name} gespeichert",
  descriptionForFunction: "Beschreibung für Funktion \"{name}\" (optional):",
  clashExist: "{bits} sind bereits vorhanden. Umbenennen behält beide (Standard). Ersetzen überschreibt die vorhandene Definition.",
  functionQuoted: "Funktion \"{name}\"",
  decisionQuoted: "Entscheidungstabelle \"{name}\"",
  andWord: "und",
  openedContributionIssue: "Beitrags-Issue für {name} geöffnet",
  openedGithubForm: "GitHub-Formular für neues Issue für {name} geöffnet",
  entrySummary: "{description} Parameter: {params}. Entscheidungstabellen: {tables}.",
  recommendedFrozen: "Sie verwenden intEHRgrator {current}, nicht die empfohlene Endnutzerversion ({recommended}).",
  recommendedBleeding: "Sie verwenden den aktuellen Build (aktualisiert bei jeder Änderung an main), nicht die empfohlene stabile Version ({recommended}).",
  goToRecommended: "Zur empfohlenen Version ({tag})",
  previewingSeq: "Vorschau von Seq {n}…",
  previewLoadedSeq: "Vorschau für Seq {n} geladen (schreibgeschützt; Hauptfläche unverändert).",
  rollbackAsk: "Auf Seq {seq} zurücksetzen?\n\n{n} spätere Einträge werden verworfen.\n\nVerworfenen Zweig (.intehrgrator) vor dem Fortfahren herunterladen?",
  confirmRollback: "Destruktives Zurücksetzen auf Seq {seq} bestätigen?",
  rolledBackSeq: "Auf Seq {n} zurückgesetzt. Die Hauptfläche wird synchronisiert.",
  patchPromptCopied: "Patch-Prompt kopiert (intehrgrator-suggestions v2). Anwenden über import_suggestions.",
  optionalAttributes: "Optionale Attribute…",
  openViewerMenu: "Ansichtsfenster öffnen…",
  noAgentsYet: "Noch keine Agenten verbunden.",
  aiChatHistoryTrimmed: "Ältere Chat-Runden wurden entfernt, damit die Anfrage unter {limit} Tokens bleibt (die API sendet bei jedem Schritt den ganzen Chat); diese Nachricht hängt den Projektkontext erneut an.",
  aiChatHistoryFull: "Nichts gesendet: Der Chatverlauf hat etwa {tokens} Tokens, über dem Limit von {limit} für dieses Modell, und der ganze Verlauf geht mit jeder Anfrage mit. Wie möchten Sie fortfahren?",
  aiChatHistoryTrimChoice: "Mit gekürztem Verlauf fortfahren",
  aiChatHistoryRecapChoice: "Neuen Chat mit Zusammenfassung starten",
  aiChatHistoryCancelChoice: "Abbrechen",
  aiChatHistoryRecapStarted: "Neuer Chat gestartet. Eine Zusammenfassung des bisherigen Chats (Ihre Nachrichten, die Antworten und die Mappings) geht mit Ihrer Nachricht mit, zusammen mit dem Projektkontext.",
  aiChatHistoryCancelled: "Nicht gesendet. Ihre Nachricht steht noch im Eingabefeld.",
  aiChatStorageTrimmed: "Dieser Chat ist größer, als der Browser speichert ({limit} Zeichen). Diese Seite behält den ganzen Chat, aber nach einem Neuladen bleiben nur die neuesten Runden.",
};
